<template>
  <div class="empty-state mx-4 flex flex-col items-center justify-center">
    <icon-base height="70" width="70" :icon="IconNotesEmpty" />
    <lf-h3 class="mt-5">
      {{ emptyNotesStateTitle }}
    </lf-h3>
    <div class="mt-3 px-5 text-center text-base">
      {{ emptyNotesStateText }}
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { NoteType } from "@/enums/dealActivity";

import IconNotesEmpty from "@/components/icons/IconNotesEmpty.vue";
import IconBase from "@/components/ui/IconBase.vue";
import LfH3 from "@/components/ui/text/LfHeading3.vue";

const { t } = useI18n();

const { noteType } = defineProps<{ noteType: NoteType }>();

const emptyNotesStateTitle = computed(() =>
  noteType === NoteType.Business
    ? t("DEALS.BUSINESS_NOTES.EMPTY_STATE_TITLE")
    : t("DEALS.DEAL_NOTES.EMPTY_STATE_TITLE")
);

const emptyNotesStateText = computed(() =>
  t("DEALS.DEAL_NOTES.EMPTY_STATE_DESCRIPTION", {
    type:
      noteType === NoteType.Business
        ? t("COMMON.BUSINESS").toLowerCase()
        : t("COMMON.DEAL").toLowerCase(),
    group:
      noteType === NoteType.Business
        ? t("DEALS.DEAL_NOTES.EMPTY_STATE_GROUP_BUSINESS")
        : t("DEALS.DEAL_NOTES.EMPTY_STATE_GROUP"),
  })
);
</script>
<style>
@reference "@/assets/tailwind.css";

/**
  visible content (header, input) height:
  desktop - 300px
  mobile - 130px
*/

.empty-state {
  @apply h-[calc(100vh-300px)];
}

@container (max-height: 430px) {
  .empty-state {
    height: calc(100% - 130px);
  }
  .empty-state svg {
    display: none !important;
  }
}

@container (max-height: 350px) {
  .empty-state h3,
  .empty-state div {
    @apply mt-0 text-xs leading-normal;
  }
}
</style>
